import React from 'react'
import 'components/input/input.styl'
import Tooltip from 'components/tooltip/tooltip'
import debounce from 'lodash.debounce'
import styled, { css } from 'styled-components'
import { formatValue } from 'state/utils'

class Input extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      type: this.props.type,
      dropdownInfo: this.props.dropdownInfo,
      options: this.props.options,
      selectedOption: this.props.selectedOption,
      field: "",
      isFocused: false,
    }

    this.handleRadioChange = this.handleRadioChange.bind(this)
    this.handleTextChange = this.handleTextChange.bind(this)
    this.handleNumberChange = this.handleNumberChange.bind(this)
  }

  componentWillReceiveProps(nextProps){
    if(this.props.options !== nextProps.options){
      this.setState({
        options: nextProps.options
      })
    }

    if(this.props.dropdownInfo !== nextProps.dropdownInfo){
      this.setState({
        dropdownInfo: nextProps.dropdownInfo
      })
    }

    if(this.props.selectedOption !== nextProps.selectedOption){
      this.setState({
        selectedOption: nextProps.selectedOption
      })
    }
  }

  handleRadioChange(event){
    this.setState({
      selectedOption: event.target.value
    })
    this.props.changeGlobalState("forecast",event.target.value)
  }

  handleTextChange(event){
    const re = /^[0-9\d]+$/
    var value = event.target.value
    var error = false
    if(value == ''){
      value = null
    }
    this.props.changeGlobalState(this.props.name,value,error) 
  }

  handleNumberChange(value){
    // value = numVal || 0
    var error = false
    this.props.changeGlobalState(this.props.name,value,error)
  }

  preventCharacters(value){
    if(!/[^0-9-.]/g.test(value)){
      return value || null
    } else {
      return this.props.value || 0
    }
  }

  validateInput(event){
    if(event.target.value == ''){
      this.props.changeGlobalState(this.props.name, 0)
    }else{
      if(this.props.validation == 'percent'){
        var value = Math.round(event.target.value * 10) / 10
        this.props.changeGlobalState(this.props.name,value)
      }
    }
    this.setFocus(false)
  }

  setFocus(isFocused, hasError){
    if(hasError){
      this.setState({
        isFocused: isFocused,
        hasError: hasError,
      })
    }else{
      this.setState({
        isFocused: isFocused,
        hasError: false
      })
    }
  }

  getValidNumber(value){
    value = value.toString().replace(/[^0-9-.]/g, "").replace(/(?!^)-/g,"").split('.')
    let finalValue = value.shift() + '.' + value.join('')
    
    // Ensure decimal # rounding is consistent with display value as decimal
    const roundedValue = !isNaN(parseFloat(finalValue)) 
      ? Math.round(parseFloat(finalValue)*Math.pow(10, 2))/Math.pow(10, 2) 
      : null

    return roundedValue
  }

  toggleNumberInput(isFocused,e) {
    if(!isFocused){
      this.handleNumberChange(this.getValidNumber(this.props.value || 0))
    }

    this.setState({ isFocused })
  }

  inputType(){
    var field = ''
    if(this.state.type == "text"){
      field = 
      <Input__text selected={this.state.isFocused}>
        <input 
          type="text" 
          onFocus={e => this.setFocus(true)}
          onBlur={e => this.validateInput(e)} 
          onChange={this.handleTextChange}
          size={9}
          value={this.props.value}>
        </input>
        {
          this.props.hasError == this.props.name ?
            <Tooltip type="Error" validation={this.props.validation}/>
          : <div />
        }
      </Input__text>
    }else if (this.state.type == "Number") {
      const value = !isNaN(parseFloat(this.props.value)) ? this.props.value : ''
      const formattedValue = (typeof value == 'number') && value ? formatValue(value, 2) : 0
      
      field = 
      <Input__Number selected={this.state.isFocused}>
        <input 
          type="text" 
          onFocus={e => this.toggleNumberInput(true)}
          onBlur={e => this.toggleNumberInput(false)}
          onChange={e => this.handleNumberChange(this.preventCharacters(e.target.value))}
          size={9}
          value={this.state.isFocused ? this.props.value : formattedValue}>
        </input>
        {
          this.props.hasError == this.props.name ?
            <Tooltip type="Error" validation={this.props.validation}/>
          : <div />
        }
      </Input__Number>
    }else if(this.state.type =="dropdown"){
      field = 
      <Input__dropdown>
        <select onChange={this.props.onChange}>
          {
            this.state.dropdownInfo.map(option => {
              return <option key={option.key} value={option.value} selected={this.props.value == option.value}>{option.value}</option>
            })
          }
        </select>
      </Input__dropdown>
    }else if(this.state.type == "radioButton"){
      field =         
        <form>
          <Input__radio>
          {
            this.state.options.map(option => {
              return(
                <RadioContainer>{option.text}
                  <input type="radio" value={option.forecast} onChange={this.handleRadioChange} checked={this.state.selectedOption === option.forecast} align="center"/>
                  <span className="RadioButton"></span>
                </RadioContainer>
              )
            })
          }
          </Input__radio>
        </form>
    }
    return field
  }
  render(){
    return (
      <div>{this.inputType()}</div>
    )
  }
}


export default Input

const Input__text = styled.div`
  input{
    border: 0;
    text-align: center;
    transition: box-shadow 0.3s ease-out;
    box-shadow: inset 0 -1px 0 0 lightgray
    margin: 0px 3px;
    position: relative;
  }

  ${props => props.selected && css`
    input{
      box-shadow: inset 0 -2px 0 0 #EA6A1C;
      outline: none;
    }
  `}
`
const Input__Number = styled.div`
  input{
    border: 0;
    text-align: center;
    transition: box-shadow 0.3s ease-out;
    box-shadow: inset 0 -1px 0 0 lightgray
    margin: 0px 3px;
    position: relative;
  }

  ${props => props.selected && css`
    input{
      box-shadow: inset 0 -2px 0 0 #EA6A1C;
      outline: none;
    }
  `}
`

const Input__dropdown = styled.div`
  select{
    margin-left: 10px;
    border: 0;
    outline: none;
    box-shadow: inset 0 -1px 0 0 lightgray;
  }
`

const Input__radio = styled.div`
  display: block;
  padding: 0px;

  input{
    margin-right: 10px;
  }
`

const RadioButton = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  border-radius 50%;
  border: 2px solid #b3b3b3;
`

const RadioContainer = styled.label`
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 16px;
  font-weight: 300;
  padding: 0px 25px;
  margin: 20px 0px;
  line-height: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input{
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  input:checked ~ .RadioButton{
    border: 0;
    background-color: #444444;
  }
`



// WEBPACK FOOTER //
// ./components/input/input.js